import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all regions
export const fetchRegions = createAsyncThunk("regions/fetchRegions", async (page = 1, { rejectWithValue }) => {
  try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
    const token = user?.token;
    const response = await axios.get(
      `${BASE_URL}/dashboard/regions?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      }
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Failed load data";
    return rejectWithValue(message);
  }
});

// add regions
export const addRegions = createAsyncThunk(
  "regions/add",
  async (userData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/regions`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت الإضافة بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة المنطقة";
      return rejectWithValue(message);
    }
  }
);
// get regions record
export const regionsRecord = createAsyncThunk(
  "regions/regionsRecord",
  async (id, { rejectWithValue }) => {
    try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/regions/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل بيانات المنطقة";
      return rejectWithValue(message);
    }
  }
);
// update regions
export const updateRegion = createAsyncThunk(
  "regions/updateRegion",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/regions/${id}/update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تم التحديث بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحديث المنطقة";
      return rejectWithValue(message);
    }
  }
);
// delete regions
export const deleteRegions = createAsyncThunk(
  "regions/deleteRegions",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.delete(
        `${BASE_URL}/dashboard/regions/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف المنطقة";
      return rejectWithValue(message);
    }
  }
);
const RegionsSlice = createSlice({
  name: "regions",
  initialState: {
    regions: [],
    record: null,
    meta: null,
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRegions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.meta = action.payload.meta;
        state.regions = action.payload;
      })
      .addCase(fetchRegions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addRegions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addRegions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addRegions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(regionsRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(regionsRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(regionsRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updateRegion.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateRegion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updateRegion.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deleteRegions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteRegions.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside regions
        if (state.regions?.data) {
          state.regions.data = state.regions.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.success = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteRegions.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete regions";
      });
  },
});

export const { clearState } = RegionsSlice.actions;
export default RegionsSlice.reducer;
